import displayValues from '@/assets/displayValues.json';
import { thousandSeparated } from 'shared/util/formatting';

import type { HotelReviews } from '@/interfaces';
import { GuestRatingCircle } from './components/guestRatingCircle/GuestRatingCircle';
import { GuestRatingModal } from './components/guestRatingModal/GuestRatingModal';

export const HotelPageGuestRating = ({ guestRatings, numberOfReviews }: HotelReviews) => {
    const processedGuestRatings = Object.entries(guestRatings).reduce((previousValue, currentValue) => {
        previousValue.push({
            key: currentValue[0],
            value: Number.parseFloat(currentValue[1]),
        });
        return previousValue;
    }, []);

    const overallGuestRating = processedGuestRatings.find((rating) => rating.key === 'OVERALL')?.value;

    if (!overallGuestRating || numberOfReviews <= 0) {
        return null;
    }

    return (
        <div className="grid panel panel--neutral u-ml16--gt768 u-ml0--lt768 u-mr0" data-testid="hotelPageGuestRating">
            <div className="grid__unit flex flex-align-center flex-justify-start u-size1of2--lt768 u-size1of1--gt768">
                <GuestRatingCircle guestRating={overallGuestRating} />
                <div className="u-ml16">
                    <div data-testid="guestSentiment" className="u-t4 u-mb4--gt768">
                        {displayValues.guestRatingSentiments[Math.floor(overallGuestRating)]}
                    </div>
                    <div data-testid="numberOfReviews" className="u-d1">
                        ({thousandSeparated(numberOfReviews)} vurderinger)
                    </div>
                </div>
            </div>
            {processedGuestRatings.length > 0 && (
                <GuestRatingModal guestRatings={processedGuestRatings} numberOfReviews={numberOfReviews} />
            )}
        </div>
    );
};
